import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Scrolls to top on route (pathname) change; honors in-page hash links by
// scrolling to the target element instead.
export default function ScrollToTop() {
  const { pathname, hash } = useLocation();

  useEffect(() => {
    if (hash) {
      const el = document.querySelector(hash);
      if (el) {
        el.scrollIntoView({ behavior: "auto", block: "start" });
        return;
      }
    }
    window.scrollTo(0, 0);
  }, [pathname, hash]);

  return null;
}
